export default __webpack_public_path__ + "static/media/slider_sample.f4b5e2b2.jpg";